import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";
import { useDialogContentContext } from "./DialogContext";
import { DIVIDED_REGION_CLASS } from "./styles";

export type DialogSectionProps = ComponentProps<"div">;

/** A body region of `Dialog.Content`. Stack as many as needed. */
export const DialogSection = ({ className, ...props }: DialogSectionProps) => {
  const { divided } = useDialogContentContext();

  return <div data-slot="dialog-section" className={cn(divided && DIVIDED_REGION_CLASS, className)} {...props} />;
};
